<mat-form-field     (click)="picker.open()" [id]="id">
  <input mdInput     [min]="min_date"
  [max]="max_date" disabled [ngModel]="date | date: format" />
  <input
    [min]="min_date"
    [max]="max_date"
    [hidden]="true"
    [(ngModel)]="date"
    matInput
    [matDatepicker]="picker"
    [placeholder]="placeholder | transloco"
    (dateChange)="onChange($event)"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [calendarHeaderComponent]="customHeader"></mat-datepicker>
</mat-form-field>
